/* eslint-disable */

const contentPlan = {
  card: {
    normal: [
      {
        column: "column-1",
        planIcon: "",
        buttonText: "Get Started For Free",
        labelDescription: "Enjoy the most generous free plan on the market!",
        description: "What you will get:",
        listFeature: [
          "Unlimited events & participants per month",
          "All slide types",
          "5 Quiz & 3 Poll questions per presentation",
          "Free AI features",
        ],
        more: "Learn More",
        tickColor: "#B5B5B5",
        compareDescription: 'Host any type of event<br>and effortlessly engage up to 50 participants',
      },
      {
        column: "column-2",
        planIcon: "👏🏻",
        buttonText: "Buy Now",
        labelDescription:
          "Engage your participants with unlimited quizzes, polls & activities.",
        description: "All Free features plus:",
        listFeature: [
          "Unlimited Quiz and Poll questions",
          "Submission controls",
          "Custom backgrounds",
          "Presentation privacy",
          "Folder management",
        ],
        more: "Learn More",
        tickColor: "#FF922E",
        compareDescription: 'Suitable for Trainers,<br>Teacher, Team Leaders,<br>and Event Hosts'
      },
      {
        column: "column-3",
        planIcon: "🎉",
        buttonText: "Buy Now",
        labelDescription:
          "Unlimited features.<br>Full control. Maximum engagement.",
        description: "All Essential features plus:",
        listFeature: [
          "All advanced slide settings",
          "Branding and customisation",
          "Teamplay mode",
          "Reports and analytics",
          "Data export",
          "Q&A moderation",
          "Integrations with MS Teams, Zoom, and more",
        ],
        more: "Learn More",
        tickColor: "#33C173",
        compareDescription: 'Perfect for L&D,<br>Educators, Influential Speakers and Leaders'
      },
      {
        column: "column-4",
        planIcon: "🥁",
        buttonText: "Speak to Us",
        labelDescription:
          "Transform the engagement culture of your organisation.",
        description: "We offer on-demand:",
        listFeature: [
          "Professional onboarding",
          "Single sign-on (SSO)",
          "Premium engineering support",
          "Advanced access controls",
          "Product customisation",
          "Tailored reports",
        ],
        more: "Learn More",
        tickColor: "#7669BF",
        compareDescription: 'Enterprise-grade Security, Premium Support & Customisation'
      },
    ],
    educational: [
      {
        column: "column-1",
        planIcon: "",
        buttonText: "Get Started For Free",
        labelDescription: "Enjoy the most generous free plan on the market!",
        description: "What you will get:",
        listFeature: [
          "Unlimited events & participants per month",
          "All slide types",
          "5 Quiz & 3 Poll questions per presentation",
          "Free AI features",
        ],
        more: "Learn More",
        tickColor: "#B5B5B5",
        compareDescription: 'Host any type of event and effortlessly engage up to 50 participants',
      },
      {
        column: "column-2",
        planIcon: "👏🏻",
        buttonText: "Buy Now",
        labelDescription: "Engage and empower your students!",
        description: "All Free features plus:",
        listFeature: [
          "Unlimited Quiz and Poll questions",
          "Custom backgrounds",
        ],
        more: "Learn More",
        tickColor: "#FF922E",
        compareDescription: 'Suitable for teachers with small and medium-sized classrooms',
      },
      {
        column: "column-3",
        planIcon: "🎉",
        buttonText: "Buy Now",
        labelDescription:
          "Ignite classroom discussions and track individual progress",
        description: "All Edu Small features plus:",
        listFeature: [
          "Submission controls",
          "Reports and analytics",
          "Teamplay mode",
          "Question shuffle",
          "Presentation privacy",
          "Q&A on all slides",
        ],
        more: "Learn More",
        tickColor: "#33C173",
        compareDescription: 'Ideal for educators with larger class sizes'
      },
      {
        column: "column-4",
        planIcon: "🥁",
        buttonText: "Buy Now",
        labelDescription:
          "Maximise interactions with advanced features and insights",
        description: "All Edu Medium features plus:",
        listFeature: [
          "Advanced slide settings",
          "Participant authentication",
          "Q&A moderation",
          "Data export",
          "Integration with MS Teams, Zoom, and more",
        ],
        more: "Learn More",
        tickColor: "#7669BF",
        compareDescription: 'Perfect for any educational context'
      },
    ],
  },
  plansDropdown: [
    { plan: "annual", title: "Annual plans" },
    { plan: "monthly", title: "Monthly plans" },
    { plan: "educational", title: "Educational plans" },
  ],
  comparePlan: {
    annual: {
      Participation: {
        "max-participants": {
          title: "Participants per presentation",
          tooltipVal:
            "The maximum number of people that can join a presentation simultaneously",
          planVal: ["50", "100", "Unlimited", "Unlimited"],
        },
        "audience-admission": {
          title: "Participants per month",
          tooltipVal:
            "The number of people who can participate in your presentations each month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },

        "audience-authentication": {
          title: "Presentations per month",
          tooltipVal:
            "The number of presentations you can create or host in a month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },
      },
      "Interactive Presentation": {
        quiz: {
          title: "Quiz",
          tooltipVal:
            "Including these question types: Pick Answer, Pick Image, Short Answer, Match Pairs, Correct Order",
          planVal: ["5 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "poll-wordcloud-brainstorm": {
          title: "Poll, Open Ended, Word Cloud, Brainstorm",
          tooltipVal:
            "Including these question types: Poll, Open Ended, Word Cloud, Brainstorm, Scales",
          planVal: ["3 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "live-qa": {
          title: "Live Q&A",
          tooltipVal: "Crowdsource the best questions from participants",
          planVal: [true, true, true, true],
        },
        "qa-moderation": {
          title: "Q&A Moderation",
          tooltipVal:
            "Review questions before displaying them on the screen for the participants",
          planVal: [false, false, true, true],
        },
        "qa-on-all-slides": {
          title: "Q&A on all slides",
          tooltipVal:
            "Participants can ask questions anytime during your presentation",
          planVal: [false, true, true, true],
        },
        "spinner-wheel": {
          title: "Spinner Wheel",
          tooltipVal:
            "Randomly select a participant or an idea. Great for lucky draws and raffles!",
          planVal: [true, true, true, true],
        },
        "self-paced-mode": {
          title: "Self-Paced mode",
          tooltipVal:
            "Participants answer questions independently at their own pace",
          planVal: [true, true, true, true],
        },
        "teamplay-mode": {
          title: "Teamplay mode",
          tooltipVal:
            "Participants can play quizzes and be ranked as teams instead of individually",
          planVal: [false, false, true, true],
        },
        "shuffle-answer-questions": {
          title: "Shuffle answer options",
          tooltipVal:
            "Randomly rearrange the options to prevent participants from cheating",
          planVal: [false, false, true, true],
        },
        "manually-reveal-quiz-answers": {
          title: "Manually reveal Quiz answers",
          tooltipVal: "Decide when to show your participants the quiz answers",
          planVal: [false, true, true, true],
        },
        "hide-results": {
          title: "Hide results",
          tooltipVal:
            "Keep your poll, vote, and survey results discreetly from all participants. Choose to show or hide the results during live events",
          planVal: [false, false, true, true],
        },
        "advanced-submission-controls": {
          title: "Advanced submission controls",
          tooltipVal:
            "Lock or unlock submissions, or add a countdown timer during live presentations",
          planVal: [false, true, true, true],
        },
        "video-call": {
          title: "Video Call",
          tooltipVal:
            "Video call any participant and display the conversation on the presenting screen",
          planVal: [false, false, true, true],
        },
        "content-and-multimedia-slides": {
          title: "Content and multimedia slides",
          tooltipVal:
            "Enhance the content with images, animations, and videos for better engagement",
          planVal: [true, true, true, true],
        },
      },
      AI: {
        "ai-smart-grouping": {
          title: "AI smart grouping",
          tooltipVal:
            "Group Word Cloud and Open Ended responses by meaning using AI",
          planVal: [true, true, true, true],
        },
        "presentation-summary": {
          title: "Presentation summary",
          tooltipVal: "Auto-write a summary for your presentation",
          planVal: [true, true, true, true],
        },
        'pdf-ppt-to-quiz-generator': {
          title: 'PDF/PPT-to-Quiz Generator',
          tooltipVal: 'Instantly convert imported PDFs or PowerPoints into engaging quizzes with our AI',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-1'
        },
        'ai-slides-generator': {
          title: 'AI Slides Generator',
          tooltipVal: 'Effortlessly generate engaging slides tailored to your needs by writing your own prompts',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-2'
        },
      },
      "Teamwork & Collaboration": {
        "co-editing-with-team-members": {
          title: "Co-editing with team members",
          tooltipVal:
            "Invite your peers to join your AhaSlides team and collaborate with you on your presentations",
          planVal: [true, true, true, true],
        },
        "co-editing-with-guests": {
          title: "Co-editing with guests",
          tooltipVal:
            "Work with people outside of your organisation to edit a presentation",
          planVal: [false, false, true, true],
        },
        "folder-management": {
          title: "Folder management",
          tooltipVal: "Organize your files in folders and sub-folders",
          planVal: [false, true, true, true],
        },
        "present-only-role": {
          title: "Present-only role",
          tooltipVal:
            "Enable others to host your presentations without editing access",
          planVal: [false, false, true, true],
        },
      },
      "Report & Analytics": {
        "event-analytics": {
          title: "Event analytics",
          tooltipVal:
            "View engagement data and insights about your hosted presentation",
          planVal: [true, true, true, true],
        },
        "participants-report": {
          title: "Participants report",
          tooltipVal:
            "See all participants' attendance, engagement level, and performance across your events",
          planVal: [false, false, true, true],
        },
        "export-to-pdf-jpg": {
          title: "Export to PDF/JPG",
          tooltipVal:
            "Export your slides, including participant responses, to a PDF document or a set of JPG images",
          planVal: [false, true, true, true],
        },
        "export-data-to-excel": {
          title: "Export data to Excel",
          tooltipVal:
            "Export your presentation engagement data to Excel files for in-depth analysis",
          planVal: [false, false, true, true],
        },
        "tailored-reports": {
          title: "Tailored reports",
          tooltipVal:
            "We provide customised data reports tailored to your company's needs",
          planVal: [false, false, false, true],
        },
        "private-feedback": {
          title: "Private feedback",
          tooltipVal:
            "Enable participants to send private feedback during the presentation",
          planVal: [true, true, true, true],
        },
      },
      "Branding & Customisation": {
        "premium-fonts-library": {
          title: "Premium Fonts Library",
          tooltipVal:
            "Have access to a range of beautiful designer fonts including non-Latin characters",
          planVal: [false, false, true, true],
        },
        "custom-backgrounds": {
          title: "Custom backgrounds",
          tooltipVal:
            "Change the text color, background color, and background images to make your slides truly yours",
          planVal: [false, true, true, true],
        },
        audio: {
          title: "Audio",
          tooltipVal:
            "Add custom audio tracks playable by both the presenter and participants on any slide for a more interactive presentation",
          planVal: [false, false, true, true],
        },
        logo: {
          title: "Logo",
          tooltipVal:
            "Replace the AhaSlides logo with your own and make it highly visible on both the presenter and participant screens",
          planVal: [false, false, true, true],
        },
        "custom-presentation-link": {
          title: "Custom presentation link",
          tooltipVal:
            "Set a short and memorable link for your presentation, making it easy for participants to join",
          planVal: [false, false, true, true],
        },
        "hide-ahaslides-link": {
          title: "Hide AhaSlides link",
          tooltipVal:
            "Hide the AhaSlides link at the end of each presentation (on the participant screen)",
          planVal: [false, false, true, true],
        },
      },
      Intergrations: {
        powerpoint: {
          title: "PowerPoint",
          tooltipVal:
            "Integrate AhaSlides directly into your PowerPoint presentation via the AhaSlides Add-in",
          planVal: [true, true, true, true],
        },
        "import-ppt-pdf": {
          title: "Import PowerPoint/PDF",
          tooltipVal:
            "Import your existing PPT, PPTX, and PDF files into your AhaSlides presentation",
          planVal: [true, true, true, true],
        },
        "ms-teams": {
          title: "MS Teams",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Microsoft Teams Meetings and Webinars",
          planVal: [false, false, true, true],
        },
        zoom: {
          title: "Zoom",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Zoom Meetings and Webinars",
          planVal: [false, false, true, true],
        },
        hopin: {
          title: "Hopin",
          tooltipVal: "Integrate AhaSlides directly into your Hopin event",
          planVal: [false, false, true, true],
        },
      },
      "Privacy & Control": {
        "participant-info-collection": {
          title: "Participant info collection",
          tooltipVal:
            "Ask participants to provide their name, email, and organization when joining the presentation",
          planVal: [false, true, true, true],
        },
        "participant-authentication": {
          title: "Participant authentication",
          tooltipVal:
            "Requires participants to enter a secret code you've set to join your presentation)",
          planVal: [false, false, true, true],
        },
        "make-presentations-private": {
          title: "Make presentations private",
          tooltipVal: "Control who can see your presentations",
          planVal: [false, true, true, true],
        },
        "slides-review-control": {
          title: "Slides Review control",
          tooltipVal: "Control participants' access to look back at the slides",
          planVal: [false, false, true, true],
        },
        "user-single-sign-on": {
          title: "User Single Sign-on (SSO)",
          tooltipVal:
            "Enable your team members to log in with your organisation credentials",
          planVal: [false, false, false, true],
        },
        "participant-email-verification": {
          title: "Participant email verification",
          tooltipVal:
            "Control access to your event based on the participant's email address or domain name",
          planVal: [false, false, false, true],
        },
      },
      Support: {
        "live-support": {
          title: "Live support",
          tooltipVal:
            "Receive direct online assistance from our Customer Success Managers via email and live chat",
          planVal: [true, true, true, true],
        },
        "premium-engineering-support": {
          title: "Premium engineering support",
          tooltipVal:
            "Expert technical assistance for any product-related issue",
          planVal: [false, false, false, true],
        },
        "professional-onboarding": {
          title: "Professional onboarding",
          tooltipVal:
            "Receive professional onboarding services through workshops and training sessions to ensure your organisation gets the most value from AhaSlides",
          planVal: [false, false, false, true],
        },
        "product-customisation": {
          title: "Product customisation",
          tooltipVal: "Need further customisation? Contact us to learn more",
          planVal: [false, false, false, true],
        },
      },
    },
    monthly: {
      Participation: {
        "max-participants": {
          title: "Participants per presentation",
          tooltipVal:
            "The maximum number of people that can join a presentation simultaneously",
          planVal: ["50", "100", "Unlimited", "Unlimited"],
        },
        "audience-admission": {
          title: "Participants per month",
          tooltipVal:
            "The number of people who can participate in your presentations each month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },

        "audience-authentication": {
          title: "Presentations per month",
          tooltipVal:
            "The number of presentations you can create or host in a month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },
      },
      "Interactive Presentation": {
        quiz: {
          title: "Quiz",
          tooltipVal:
            "Including these question types: Pick Answer, Pick Image, Short Answer, Match Pairs, Correct Order",
          planVal: ["5 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "poll-wordcloud-brainstorm": {
          title: "Poll, Open Ended, Word Cloud, Brainstorm",
          tooltipVal:
            "Including these question types: Poll, Open Ended, Word Cloud, Brainstorm, Scales",
          planVal: ["3 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "live-qa": {
          title: "Live Q&A",
          tooltipVal: "Crowdsource the best questions from participants",
          planVal: [true, true, true, true],
        },
        "qa-moderation": {
          title: "Q&A Moderation",
          tooltipVal:
            "Review questions before displaying them on the screen for the participants",
          planVal: [false, false, true, true],
        },
        "qa-on-all-slides": {
          title: "Q&A on all slides",
          tooltipVal:
            "Participants can ask questions anytime during your presentation",
          planVal: [false, true, true, true],
        },
        "spinner-wheel": {
          title: "Spinner Wheel",
          tooltipVal:
            "Randomly select a participant or an idea. Great for lucky draws and raffles!",
          planVal: [true, true, true, true],
        },
        "self-paced-mode": {
          title: "Self-Paced mode",
          tooltipVal:
            "Participants answer questions independently at their own pace",
          planVal: [true, true, true, true],
        },
        "teamplay-mode": {
          title: "Teamplay mode",
          tooltipVal:
            "Participants can play quizzes and be ranked as teams instead of individually",
          planVal: [false, false, true, true],
        },
        "shuffle-answer-questions": {
          title: "Shuffle answer options",
          tooltipVal:
            "Randomly rearrange the options to prevent participants from cheating",
          planVal: [false, false, true, true],
        },
        "manually-reveal-quiz-answers": {
          title: "Manually reveal Quiz answers",
          tooltipVal: "Decide when to show your participants the quiz answers",
          planVal: [false, true, true, true],
        },
        "hide-results": {
          title: "Hide results",
          tooltipVal:
            "Keep your poll, vote, and survey results discreetly from all participants. Choose to show or hide the results during live events",
          planVal: [false, false, true, true],
        },
        "advanced-submission-controls": {
          title: "Advanced submission controls",
          tooltipVal:
            "Lock or unlock submissions, or add a countdown timer during live presentations",
          planVal: [false, true, true, true],
        },
        "video-call": {
          title: "Video Call",
          tooltipVal:
            "Video call any participant and display the conversation on the presenting screen",
          planVal: [false, false, true, true],
        },
        "content-and-multimedia-slides": {
          title: "Content and multimedia slides",
          tooltipVal:
            "Enhance the content with images, animations, and videos for better engagement",
          planVal: [true, true, true, true],
        },
      },
      AI: {
        "ai-smart-grouping": {
          title: "AI smart grouping",
          tooltipVal:
            "Group Word Cloud and Open Ended responses by meaning using AI",
          planVal: [true, true, true, true],
        },
        "presentation-summary": {
          title: "Presentation summary",
          tooltipVal: "Auto-write a summary for your presentation",
          planVal: [true, true, true, true],
        },
        'pdf-ppt-to-quiz-generator': {
          title: 'PDF/PPT-to-Quiz Generator',
          tooltipVal: 'Instantly convert imported PDFs or PowerPoints into engaging quizzes with our AI',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-1'
        },
        'ai-slides-generator': {
          title: 'AI Slides Generator',
          tooltipVal: 'Effortlessly generate engaging slides tailored to your needs by writing your own prompts',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-2'
        },
      },
      "Teamwork & Collaboration": {
        "co-editing-with-team-members": {
          title: "Co-editing with team members",
          tooltipVal:
            "Invite your peers to join your AhaSlides team and collaborate with you on your presentations",
          planVal: [true, true, true, true],
        },
        "co-editing-with-guests": {
          title: "Co-editing with guests",
          tooltipVal:
            "Work with people outside of your organisation to edit a presentation",
          planVal: [false, false, true, true],
        },
        "folder-management": {
          title: "Folder management",
          tooltipVal: "Organize your files in folders and sub-folders",
          planVal: [false, true, true, true],
        },
        "present-only-role": {
          title: "Present-only role",
          tooltipVal:
            "Enable others to host your presentations without editing access",
          planVal: [false, false, true, true],
        },
      },
      "Report & Analytics": {
        "event-analytics": {
          title: "Event analytics",
          tooltipVal:
            "View engagement data and insights about your hosted presentation",
          planVal: [true, true, true, true],
        },
        "participants-report": {
          title: "Participants report",
          tooltipVal:
            "See all participants' attendance, engagement level, and performance across your events",
          planVal: [false, false, true, true],
        },
        "export-to-pdf-jpg": {
          title: "Export to PDF/JPG",
          tooltipVal:
            "Export your slides, including participant responses, to a PDF document or a set of JPG images",
          planVal: [false, true, true, true],
        },
        "export-data-to-excel": {
          title: "Export data to Excel",
          tooltipVal:
            "Export your presentation engagement data to Excel files for in-depth analysis",
          planVal: [false, false, true, true],
        },
        "tailored-reports": {
          title: "Tailored reports",
          tooltipVal:
            "We provide customised data reports tailored to your company's needs",
          planVal: [false, false, false, true],
        },
        "private-feedback": {
          title: "Private feedback",
          tooltipVal:
            "Enable participants to send private feedback during the presentation",
          planVal: [true, true, true, true],
        },
      },
      "Branding & Customisation": {
        "premium-fonts-library": {
          title: "Premium Fonts Library",
          tooltipVal:
            "Have access to a range of beautiful designer fonts including non-Latin characters",
          planVal: [false, false, true, true],
        },
        "custom-backgrounds": {
          title: "Custom backgrounds",
          tooltipVal:
            "Change the text color, background color, and background images to make your slides truly yours",
          planVal: [false, true, true, true],
        },
        audio: {
          title: "Audio",
          tooltipVal:
            "Add custom audio tracks playable by both the presenter and participants on any slide for a more interactive presentation",
          planVal: [false, false, true, true],
        },
        logo: {
          title: "Logo",
          tooltipVal:
            "Replace the AhaSlides logo with your own and make it highly visible on both the presenter and participant screens",
          planVal: [false, false, true, true],
        },
        "custom-presentation-link": {
          title: "Custom presentation link",
          tooltipVal:
            "Set a short and memorable link for your presentation, making it easy for participants to join",
          planVal: [false, false, true, true],
        },
        "hide-ahaslides-link": {
          title: "Hide AhaSlides link",
          tooltipVal:
            "Hide the AhaSlides link at the end of each presentation (on the participant screen)",
          planVal: [false, false, true, true],
        },
      },
      Intergrations: {
        powerpoint: {
          title: "PowerPoint",
          tooltipVal:
            "Integrate AhaSlides directly into your PowerPoint presentation via the AhaSlides Add-in",
          planVal: [true, true, true, true],
        },
        "import-ppt-pdf": {
          title: "Import PowerPoint/PDF",
          tooltipVal:
            "Import your existing PPT, PPTX, and PDF files into your AhaSlides presentation",
          planVal: [true, true, true, true],
        },
        "ms-teams": {
          title: "MS Teams",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Microsoft Teams Meetings and Webinars",
          planVal: [false, false, true, true],
        },
        zoom: {
          title: "Zoom",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Zoom Meetings and Webinars",
          planVal: [false, false, true, true],
        },
        hopin: {
          title: "Hopin",
          tooltipVal: "Integrate AhaSlides directly into your Hopin event",
          planVal: [false, false, true, true],
        },
      },
      "Privacy & Control": {
        "participant-info-collection": {
          title: "Participant info collection",
          tooltipVal:
            "Ask participants to provide their name, email, and organization when joining the presentation",
          planVal: [false, true, true, true],
        },
        "participant-authentication": {
          title: "Participant authentication",
          tooltipVal:
            "Requires participants to enter a secret code you've set to join your presentation)",
          planVal: [false, false, true, true],
        },
        "make-presentations-private": {
          title: "Make presentations private",
          tooltipVal: "Control who can see your presentations",
          planVal: [false, true, true, true],
        },
        "slides-review-control": {
          title: "Slides Review control",
          tooltipVal: "Control participants' access to look back at the slides",
          planVal: [false, false, true, true],
        },
        "user-single-sign-on": {
          title: "User Single Sign-on (SSO)",
          tooltipVal:
            "Enable your team members to log in with your organisation credentials",
          planVal: [false, false, false, true],
        },
        "participant-email-verification": {
          title: "Participant email verification",
          tooltipVal:
            "Control access to your event based on the participant's email address or domain name",
          planVal: [false, false, false, true],
        },
      },
      Support: {
        "live-support": {
          title: "Live support",
          tooltipVal:
            "Receive direct online assistance from our Customer Success Managers via email and live chat",
          planVal: [true, true, true, true],
        },
        "premium-engineering-support": {
          title: "Premium engineering support",
          tooltipVal:
            "Expert technical assistance for any product-related issue",
          planVal: [false, false, false, true],
        },
        "professional-onboarding": {
          title: "Professional onboarding",
          tooltipVal:
            "Receive professional onboarding services through workshops and training sessions to ensure your organisation gets the most value from AhaSlides",
          planVal: [false, false, false, true],
        },
        "product-customisation": {
          title: "Product customisation",
          tooltipVal: "Need further customisation? Contact us to learn more",
          planVal: [false, false, false, true],
        },
      },
    },
    educational: {
      Participation: {
        "max-participants": {
          title: "Participants per presentation",
          tooltipVal:
            "The maximum number of people that can join a presentation simultaneously",
          planVal: ["50", "50", "100", "200"],
        },
        "audience-admission": {
          title: "Participants per month",
          tooltipVal:
            "The number of people who can participate in your presentations each month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },

        "audience-authentication": {
          title: "Presentations per month",
          tooltipVal:
            "The number of presentations you can create or host in a month",
          planVal: ["Unlimited", "Unlimited", "Unlimited", "Unlimited"],
        },
      },
      "Interactive Presentation": {
        quiz: {
          title: "Quiz",
          tooltipVal:
            "Including these question types: Pick Answer, Pick Image, Short Answer, Match Pairs, Correct Order",
          planVal: ["5 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "poll-wordcloud-brainstorm": {
          title: "Poll, Open Ended, Word Cloud, Brainstorm",
          tooltipVal:
            "Including these question types: Poll, Open Ended, Word Cloud, Brainstorm, Scales",
          planVal: ["3 questions", "Unlimited", "Unlimited", "Unlimited"],
        },
        "live-qa": {
          title: "Live Q&A",
          tooltipVal: "Crowdsource the best questions from participants",
          planVal: [true, true, true, true],
        },
        "qa-moderation": {
          title: "Q&A Moderation",
          tooltipVal:
            "Review questions before displaying them on the screen for the participants",
          planVal: [false, false, false, true],
        },
        "qa-on-all-slides": {
          title: "Q&A on all slides",
          tooltipVal:
            "Participants can ask questions anytime during your presentation",
          planVal: [false, false, false, true],
        },
        "spinner-wheel": {
          title: "Spinner Wheel",
          tooltipVal:
            "Randomly select a participant or an idea. Great for lucky draws and raffles!",
          planVal: [true, true, true, true],
        },
        "self-paced-mode": {
          title: "Self-Paced mode",
          tooltipVal:
            "Participants answer questions independently at their own pace",
          planVal: [true, true, true, true],
        },
        "teamplay-mode": {
          title: "Teamplay mode",
          tooltipVal:
            "Participants can play quizzes and be ranked as teams instead of individually",
          planVal: [false, false, true, true],
        },
        "shuffle-answer-questions": {
          title: "Shuffle answer options",
          tooltipVal:
            "Randomly rearrange the options to prevent participants from cheating",
          planVal: [false, false, true, true],
        },
        "manually-reveal-quiz-answers": {
          title: "Manually reveal Quiz answers",
          tooltipVal: "Decide when to show your participants the quiz answers",
          planVal: [false, true, true, true],
        },
        "hide-results": {
          title: "Hide results",
          tooltipVal:
            "Keep your poll, vote, and survey results discreetly from all participants. Choose to show or hide the results during live events",
          planVal: [false, false, false, true],
        },
        "advanced-submission-controls": {
          title: "Advanced submission controls",
          tooltipVal:
            "Lock or unlock submissions, or add a countdown timer during live presentations",
          planVal: [false, false, true, true],
        },
        "video-call": {
          title: "Video Call",
          tooltipVal:
            "Video call any participant and display the conversation on the presenting screen",
          planVal: [false, false, false, true],
        },
        "content-and-multimedia-slides": {
          title: "Content and multimedia slides",
          tooltipVal:
            "Enhance the content with images, animations, and videos for better engagement",
          planVal: [true, true, true, true],
        },
      },
      AI: {
        "ai-smart-grouping": {
          title: "AI smart grouping",
          tooltipVal:
            "Group Word Cloud and Open Ended responses by meaning using AI",
          planVal: [true, true, true, true],
        },
        "presentation-summary": {
          title: "Presentation summary",
          tooltipVal: "Auto-write a summary for your presentation",
          planVal: [true, true, true, true],
        },
        'pdf-ppt-to-quiz-generator': {
          title: 'PDF/PPT-to-Quiz Generator',
          tooltipVal: 'Instantly convert imported PDFs or PowerPoints into engaging quizzes with our AI',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-1'
        },
        'ai-slides-generator': {
          title: 'AI Slides Generator',
          tooltipVal: 'Effortlessly generate engaging slides tailored to your needs by writing your own prompts',
          planVal: ['5 queries per month', '20 queries per month', 'Unlimited', 'Unlimited'],
          group: 'generator-2'
        },
      },
      "Teamwork & Collaboration": {
        "co-editing-with-team-members": {
          title: "Co-editing with team members",
          tooltipVal:
            "Invite your peers to join your AhaSlides team and collaborate with you on your presentations",
          planVal: [true, true, true, true],
        },
        "co-editing-with-guests": {
          title: "Co-editing with guests",
          tooltipVal:
            "Work with people outside of your organisation to edit a presentation",
          planVal: [false, false, false, true],
        },
        "folder-management": {
          title: "Folder management",
          tooltipVal: "Organize your files in folders and sub-folders",
          planVal: [false, true, true, true],
        },
        "present-only-role": {
          title: "Present-only role",
          tooltipVal:
            "Enable others to host your presentations without editing access",
          planVal: [false, false, false, true],
        },
      },
      "Report & Analytics": {
        "event-analytics": {
          title: "Event analytics",
          tooltipVal:
            "View engagement data and insights about your hosted presentation",
          planVal: [true, true, true, true],
        },
        "participants-report": {
          title: "Participants report",
          tooltipVal:
            "See all participants' attendance, engagement level, and performance across your events",
          planVal: [false, false, true, true],
        },
        "export-to-pdf-jpg": {
          title: "Export to PDF/JPG",
          tooltipVal:
            "Export your slides, including participant responses, to a PDF document or a set of JPG images",
          planVal: [false, true, true, true],
        },
        "export-data-to-excel": {
          title: "Export data to Excel",
          tooltipVal:
            "Export your presentation engagement data to Excel files for in-depth analysis",
          planVal: [false, false, false, true],
        },
        "tailored-reports": {
          title: "Tailored reports",
          tooltipVal:
            "We provide customised data reports tailored to your company's needs",
          planVal: [false, false, false, false],
        },
        "private-feedback": {
          title: "Private feedback",
          tooltipVal:
            "Enable participants to send private feedback during the presentation",
          planVal: [true, true, true, true],
        },
      },
      "Branding & Customisation": {
        "premium-fonts-library": {
          title: "Premium Fonts Library",
          tooltipVal:
            "Have access to a range of beautiful designer fonts including non-Latin characters",
          planVal: [false, false, false, false],
        },
        "custom-backgrounds": {
          title: "Custom backgrounds",
          tooltipVal:
            "Change the text color, background color, and background images to make your slides truly yours",
          planVal: [false, true, true, true],
        },
        audio: {
          title: "Audio",
          tooltipVal:
            "Add custom audio tracks playable by both the presenter and participants on any slide for a more interactive presentation",
          planVal: [false, false, false, false],
        },
        logo: {
          title: "Logo",
          tooltipVal:
            "Replace the AhaSlides logo with your own and make it highly visible on both the presenter and participant screens",
          planVal: [false, false, false, false],
        },
        "custom-presentation-link": {
          title: "Custom presentation link",
          tooltipVal:
            "Set a short and memorable link for your presentation, making it easy for participants to join",
          planVal: [false, false, false, false],
        },
        "hide-ahaslides-link": {
          title: "Hide AhaSlides link",
          tooltipVal:
            "Hide the AhaSlides link at the end of each presentation (on the participant screen)",
          planVal: [false, false, false, false],
        },
      },
      Intergrations: {
        powerpoint: {
          title: "PowerPoint",
          tooltipVal:
            "Integrate AhaSlides directly into your PowerPoint presentation via the AhaSlides Add-in",
          planVal: [true, true, true, true],
        },
        "import-ppt-pdf": {
          title: "Import PowerPoint/PDF",
          tooltipVal:
            "Import your existing PPT, PPTX, and PDF files into your AhaSlides presentation",
          planVal: [true, true, true, true],
        },
        "ms-teams": {
          title: "MS Teams",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Microsoft Teams Meetings and Webinars",
          planVal: [false, false, false, true],
        },
        zoom: {
          title: "Zoom",
          tooltipVal:
            "Keep your participants engaged with AhaSlides directly in your Zoom Meetings and Webinars",
          planVal: [false, false, false, true],
        },
        hopin: {
          title: "Hopin",
          tooltipVal: "Integrate AhaSlides directly into your Hopin event",
          planVal: [false, false, false, true],
        },
      },
      "Privacy & Control": {
        "participant-info-collection": {
          title: "Participant info collection",
          tooltipVal:
            "Ask participants to provide their name, email, and organization when joining the presentation",
          planVal: [false, true, true, true],
        },
        "participant-authentication": {
          title: "Participant authentication",
          tooltipVal:
            "Requires participants to enter a secret code you've set to join your presentation)",
          planVal: [false, false, false, true],
        },
        "make-presentations-private": {
          title: "Make presentations private",
          tooltipVal: "Control who can see your presentations",
          planVal: [false, true, true, true],
        },
        "slides-review-control": {
          title: "Slides Review control",
          tooltipVal: "Control participants' access to look back at the slides",
          planVal: [false, false, false, false],
        },
        "user-single-sign-on": {
          title: "User Single Sign-on (SSO)",
          tooltipVal:
            "Enable your team members to log in with your organisation credentials",
          planVal: [false, false, false, false],
        },
        "participant-email-verification": {
          title: "Participant email verification",
          tooltipVal:
            "Control access to your event based on the participant's email address or domain name",
          planVal: [false, false, false, false],
        },
      },
      Support: {
        "live-support": {
          title: "Live support",
          tooltipVal:
            "Receive direct online assistance from our Customer Success Managers via email and live chat",
          planVal: [true, true, true, true],
        },
        "premium-engineering-support": {
          title: "Premium engineering support",
          tooltipVal:
            "Expert technical assistance for any product-related issue",
          planVal: [false, false, false, false],
        },
        "professional-onboarding": {
          title: "Professional onboarding",
          tooltipVal:
            "Receive professional onboarding services through workshops and training sessions to ensure your organisation gets the most value from AhaSlides",
          planVal: [false, false, false, false],
        },
        "product-customisation": {
          title: "Product customisation",
          tooltipVal: "Need further customisation? Contact us to learn more",
          planVal: [false, false, false, true],
        },
      },
    },
  },
};

export default contentPlan;
